<template>
  <admin-wrapper
    title-translation-path="admin.masterplanPdfSettings.title"
    subtitle-path="admin.masterplanPdfSettings.subtitle"
    :inputs="inputs"
    @save="onSave"
  >
    <template #[`logo1.input`]="{dropzoneOptions}">
      <file-input-image
        class="pl-3"
        :options="dropzoneOptions"
        type="customLogo"
        name="masterplan_logo_1.png"
        :max-height="200"
        :max-width="500"
      />
    </template>
    <template #[`logo2.input`]="{dropzoneOptions}">
      <file-input-image
        class="pl-3"
        :options="dropzoneOptions"
        type="customLogo"
        name="masterplan_logo_2.png"
        :max-height="200"
        :max-width="500"
      />
    </template>
    <template #[`logo3.input`]="{dropzoneOptions}">
      <file-input-image
        class="pl-3"
        type="customLogo"
        name="masterplan_logo_3.png"
        :options="dropzoneOptions"
        :max-height="200"
        :max-width="500"
      />
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import FileInputImage from '@/components/FileInputImage';

export default {
  name: 'MasterplanPdfSettings',
  components: {
    AdminWrapper,
    FileInputImage,
  },
  data: () => ({
    images: {
      logo1: {
        file: undefined,
        src: '',
        url: '',
      },
      logo2: {
        file: undefined,
        src: '',
        url: '',
      },
      logo3: {
        file: undefined,
        src: '',
        url: '',
      },
    },
  }),
  mounted() {
    this.refreshLogos();
  },
  computed: {
    token: get('authentication/token'),
    logoDefaultParams() {
      return {
        translationPath: 'admin.masterplanPdfSettings.logoTitle',
        subtitle: 'admin.masterplanPdfSettings.logoSubtitle',
        align: 'start',
        isCustom: true,
      };
    },
    logoDefaultDropzoneParams() {
      return {
        url: '/',
        acceptedFiles: '.png,.jpeg,.jpg',
        maxFiles: 1,
        autoProcessQueue: false,
        init: function() {
          this.on('addedfile', function() {
            this.removeAllFiles(true);
          });
        },
      };
    },
    textDefaultParams() {
      return {
        translationPath: 'admin.masterplanPdfSettings.textTitle',
        subtitle: 'admin.masterplanPdfSettings.upperTextSubtitle',
        clearable: true,
        dataType: {
          name: 'text',
          max_length: 70,
        },
      };
    },
    inputs() {
      return [
        {
          ...this.logoDefaultParams,
          name: 'logo1',
          translationPathParams: {
            number: 1,
          },
          dropzoneOptions: {
            ...this.logoDefaultDropzoneParams,
            urlFile: this.images.logo1.src ? this.images.logo1.src : this.images.logo1.url,
            urlGet: this.images.logo1.url,
            accept: file => {
              this.images.logo1.file = file;
              this.images.logo1.src = URL.createObjectURL(file);
              const img = new Image();
              img.src = this.images.logo1.src;
            },
          },
        },
        {
          ...this.logoDefaultParams,
          name: 'logo2',
          translationPathParams: {
            number: 2,
          },
          dropzoneOptions: {
            ...this.logoDefaultDropzoneParams,
            urlFile: this.images.logo2.src ? this.images.logo2.src : this.images.logo2.url,
            urlGet: this.images.logo2.url,
            accept: file => {
              this.images.logo2.file = file;
              this.images.logo2.src = URL.createObjectURL(file);
              const img = new Image();
              img.src = this.images.logo2.src;
            },
          },
        },
        {
          ...this.logoDefaultParams,
          name: 'logo3',
          translationPathParams: {
            number: 3,
          },
          dropzoneOptions: {
            ...this.logoDefaultDropzoneParams,
            urlFile: this.images.logo3.src ? this.images.logo3.src : this.images.logo3.url,
            urlGet: this.images.logo3.url,
            accept: file => {
              this.images.logo3.file = file;
              this.images.logo3.src = URL.createObjectURL(file);
              const img = new Image();
              img.src = this.images.logo3.src;
            },
          },
        },
        {
          ...this.textDefaultParams,
          name: 'masterplan_pdf_text_1',
          translationPathParams: {
            number: 1,
          },
        },
        {
          ...this.textDefaultParams,
          name: 'masterplan_pdf_text_2',
          translationPathParams: {
            number: 2,
          },
        },
      ];
    },
  },
  methods: {
    putCustomLogo: call('admin/putCustomLogo'),
    async onSave() {
      if (this.images.logo1.file && this.images.logo1.src) {
        const formData = new FormData();
        formData.append('logo', this.images.logo1.file);
        await this.putCustomLogo({ name: 'masterplan_logo_1.png', formData });
        this.images.logo1.file = undefined;
        this.images.logo1.src = '';
      }
      if (this.images.logo2.file && this.images.logo2.src) {
        const formData = new FormData();
        formData.append('logo', this.images.logo2.file);
        await this.putCustomLogo({ name: 'masterplan_logo_2.png', formData });
        this.images.logo2.file = undefined;
        this.images.logo2.src = '';
      }
      if (this.images.logo3.file && this.images.logo3.src) {
        const formData = new FormData();
        formData.append('logo', this.images.logo3.file);
        await this.putCustomLogo({ name: 'masterplan_logo_3.png', formData });
        this.images.logo3.file = undefined;
        this.images.logo3.src = '';
      }
      this.refreshLogos();
    },
    refreshLogos() {
      this.images.logo1.url = `${process.env.VUE_APP_API_URL}/settings/logo/masterplan_logo_1.png?token=${
        this.token
      }&cache=${Date.now()}`;
      this.images.logo2.url = `${process.env.VUE_APP_API_URL}/settings/logo/masterplan_logo_2.png?token=${
        this.token
      }&cache=${Date.now()}`;
      this.images.logo3.url = `${process.env.VUE_APP_API_URL}/settings/logo/masterplan_logo_3.png?token=${
        this.token
      }&cache=${Date.now()}`;
    },
  },
};
</script>

<style scoped lang="scss"></style>
